import Typography from "@mui/material/Typography";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { Container } from "@mui/material";

export const PageLayout = (props) => {
    return (
        <>
            <NavBar />
            <br />
            {props.children}
            <br />
            <Footer />
        </>
    );
};